import {
    ConnectAppRequest,
    ConnectedAppDetailsResponse,
    ConnectedAppResponse,
    IOwnerAppsApi,
    PotentialAppDetailsResponse,
    PotentialAppResponse,
    UpdateConnectedAppScopesRequest,
} from '@servicetitan/public-api-app-mgmt';
import { inject, injectable, symbolToken } from '@servicetitan/react-ioc';

import { ApiGroup, APP_API_TOKEN, IAppApi } from '../../api/app.api';

export const API_GROUP_TOKEN = symbolToken<ApiGroup>('API_GROUP_TOKEN');
export const OWNER_TOKEN = symbolToken<string>('OWNER_TOKEN');

@injectable()
export class OwnerAppsApi implements IOwnerAppsApi {
    constructor(
        @inject(APP_API_TOKEN) private readonly appApi: IAppApi,
        @inject(API_GROUP_TOKEN) private readonly apiGroup: ApiGroup,
        @inject(OWNER_TOKEN) private readonly owner: string,
    ) {}

    getOwnerId(): Promise<string> {
        return Promise.resolve(this.owner);
    }

    acceptTerms(potentialAppPublicId: string): Promise<void> {
        return this.appApi.acceptClientsTerms(this.apiGroup.name, this.owner, potentialAppPublicId);
    }

    getConnectedApps(): Promise<ConnectedAppResponse[]> {
        return this.appApi.getConnectedApps(this.apiGroup.name, this.owner);
    }

    deleteConnectedApps(connectedAppIds: string[]): Promise<void> {
        return this.appApi.deleteConnectedApps(this.apiGroup.name, this.owner, connectedAppIds);
    }

    getConnectedApp(connectedAppId: string): Promise<ConnectedAppDetailsResponse> {
        return this.appApi.getConnectedApp(this.apiGroup.name, this.owner, connectedAppId);
    }

    getPotentialApps(): Promise<PotentialAppResponse[]> {
        return this.appApi.getPotentialApps(this.apiGroup.name, this.owner);
    }

    getPotentialApp(publicId: string, scopesVersion: number): Promise<PotentialAppDetailsResponse> {
        return this.appApi.getPotentialAppDetails(
            this.apiGroup.name,
            this.owner,
            publicId,
            scopesVersion,
        );
    }

    connectApp(request: ConnectAppRequest): Promise<string> {
        return this.appApi.connectPotentialApp(this.apiGroup.name, this.owner, request);
    }

    updateConnectedAppScopes(
        clientId: string,
        request: UpdateConnectedAppScopesRequest,
    ): Promise<void> {
        return this.appApi.updateConnectedAppScopes(
            this.apiGroup.name,
            this.owner,
            clientId,
            request,
        );
    }

    generateClientSecret(connectedAppId: string): Promise<string> {
        return this.appApi.generateClientSecret(this.apiGroup.name, this.owner, connectedAppId);
    }

    deactivateClientSecret(connectedAppId: string, secretId: string): Promise<void> {
        return this.appApi.deactivateClientSecret(
            this.apiGroup.name,
            this.owner,
            connectedAppId,
            secretId,
        );
    }

    disableConnectedApps(connectedAppIds: string[]): Promise<void> {
        return this.appApi.disableConnectedApps(this.apiGroup.name, this.owner, connectedAppIds);
    }

    enableConnectedApps(connectedAppIds: string[]): Promise<void> {
        return this.appApi.enableConnectedApps(this.apiGroup.name, this.owner, connectedAppIds);
    }
}
